import initGsapScrollState from "../triggers/gsapScrollState";
import initGsapAos from "../triggers/gsapAos";
import initGsapUnveil from "../triggers/gsapUnveil";
import initGsapMarquee from "../triggers/gsapMarquee";
import initGsapOdometer from "../triggers/gsapOdometer";

export default function initGsapTriggers() {
    initGsapScrollState();
    initGsapAos();
    initGsapMarquee();
    initGsapOdometer();
    if (MNK) initGsapUnveil();
}
